import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import {
    GET_DMT_PARTNER_REFUND_PENDING_HISTORY,
    POST_DMT_REFUND_TRANSACTION,
    POST_DMT_REFUND_OTP_REQUEST_TRANSACTION,
    POST_INSTANT_PAY_REFUND_OTP_REQUEST,
    POST_INSTANT_PAY_REFUND_REQUEST
} from './../../Utils/appConstants';
import { INRFormat, dmtDetailStatus, isNumber } from './../../Utils/Common';
import { getRequest, postRequest } from './../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import PropagateLoader from "react-spinners/PropagateLoader";
import { DatePicker, Modal, Tooltip, Tag } from 'antd';
import { getUTCToLocalDateTimeFormat, queryDate } from '../../Utils/function';

function RefundHistory(props) {
    const history = useHistory();
    const limit = 10;
    const dateFormat = 'DD-MM-YYYY';

    // OTP timer states
    const [otpTimer, setOtpTimer] = useState(45);
    const [isTimerActive, setIsTimerActive] = useState(false);
    const [refundOtpRef, setRefundOtpRef] = useState(null);
    const [prefix, setPrefix] = useState('');
    const timerIntervalRef = useRef(null);

    // Search / filter states
    const [searchAccountNumber, setSearchAccountNumber] = useState(null);
    const [searchTransId, setSearchTransId] = useState(null);
    const [searchCustomerId, setSearchCustomerId] = useState(null);

    const [isLoading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [getData, setData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [refundData, setRefundData] = useState(null);
    const [page, setPage] = useState(1);
    const [isLimit, setLimit] = useState(limit);
    const [userId, setUserId] = useState(props.userId);
    const [isOtp, setOtp] = useState(null);
    const [isOtpModal, setOtpModal] = useState(false);
    const [otpSending, setOtpSending] = useState(false);

    const columns = [{
        name: 'Date Time',
        cell: row => getUTCToLocalDateTimeFormat(row.createdAt),
        width: "180px",
    }, {
        name: 'Trans ID',
        selector: row => <Tooltip placement="bottom" title={row.transactionId}>{row.transactionId}</Tooltip>,
        width: "180px",
    }, {
        name: 'Customer ID',
        selector: row => <Tooltip placement="bottom" title={row.customer_id}>{row.customer_id}</Tooltip>,
        width: "130px",
    }, {
        name: 'IFSC Code',
        selector: row => row.baneData && row.baneData.ifscCode,
        width: "120px",
    }, {
        name: 'Account Number',
        selector: row => row.baneData && row.baneData.accountNumber,
        width: "170px",
    }, {
        name: 'Bene Name',
        selector: row => row.baneData && row.baneData.beneName,
        width: "190px",
    }, {
        name: 'Amount',
        selector: row => INRFormat(row.amount),
        width: "100px",
    }, {
        name: 'Status',
        selector: row => dmtDetailStatus(row.tx_status),
    }, {
        name: 'Action',
        selector: row => <><Tag color={"green"} onClick={() => refundTransaction(row)} className='pointer'> REFUND</Tag></>,
        width: "250px",
    }];

    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    };

    const params = { page: page, limit: isLimit };

    const getDataReports = (data) => {
        if (data) {
            setLimit(data);
            params.limit = data;
        }
        if (startDate && endDate) {
            params.startDate = startDate ? queryDate(startDate) : "";
            params.endDate = endDate ? queryDate(endDate) : "";
        }

        if (props.userId) {
            params.userId = userId ? userId : props.userId;
        }

        params.searchTransId = searchTransId ? searchTransId : "";
        params.searchAccountNumber = searchAccountNumber ? searchAccountNumber : "";
        params.searchCustomerId = searchCustomerId ? searchCustomerId : "";
        params.searchStatus = 3;

        const queryString = objectToQueryString(params);
        getRequest(`${GET_DMT_PARTNER_REFUND_PENDING_HISTORY}?${queryString}`, history)
            .then((response) => {
                if (response.success === true) {
                    setData(response.data);
                    setTotalRecord(response.data.totalDocs);
                    setPage(response.data.page);
                } else {
                    setData([]);
                    setTotalRecord(0);
                    setPage(1);
                }
            })
            .catch((error) => console.log(error));
    };

    // ---------- OTP Request ----------
    const sendOtpRequest = (transactionId) => {
        return new Promise((resolve, reject) => {
            setOtpSending(true);
            const pfx = transactionId.substring(0, 2);
            let apiLink;
            if (pfx === "SP") {
                apiLink = POST_DMT_REFUND_OTP_REQUEST_TRANSACTION;   // "/aeps/dmt/refundOtpBaseTransaction"
            } else {
                apiLink = POST_INSTANT_PAY_REFUND_OTP_REQUEST;        // "/service/dmt/v2/refundOtpBaseTransaction"
            }

            const payload = { transactionId };

            postRequest(apiLink, payload, history)
                .then((response) => {
                    setOtpSending(false);
                    if (response.success === true) {
                        // Store referenceKey if present (for non-SP)
                        if (response.data && response.data.referenceKey) {
                            setRefundOtpRef(response.data.referenceKey);
                        }
                        setPrefix(pfx);
                        resolve(response);
                    } else {
                        reject(new Error(response.message));
                    }
                })
                .catch((error) => {
                    setOtpSending(false);
                    reject(error);
                });
        });
    };

    // ---------- Refund Transaction ----------
    const handleRefundTransaction = () => {
        setLoading(true);
        const pfx = prefix;
        let apiLink;
        if (pfx === "SP") {
            apiLink = POST_DMT_REFUND_TRANSACTION;      // "/aeps/dmt/refundTransaction"
        } else {
            apiLink = POST_INSTANT_PAY_REFUND_REQUEST;   // "/service/dmt/v2/refundTransaction"
        }

        const payload = {
            transactionId: refundData.transactionId,
            otp: isOtp,
        };
        // For non-SP, we need the referenceKey
        if (pfx !== "SP") {
            payload.referenceKey = refundOtpRef;
        }

        postRequest(apiLink, payload, history)
            .then((response) => {
                setLoading(false);
                if (response.success === true) {
                    toast.success(response.message);
                    getDataReports();
                    handleHideModal();
                } else {
                    toast.error(response.message);
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Refund failed. Please try again.");
            });
    };

    // ---------- Open Refund Modal ----------
    const refundTransaction = (row) => {
        setRefundData(row);
        sendOtpRequest(row.transactionId)
            .then(() => {
                setOtpModal(true);
                setIsTimerActive(false);
                setOtpTimer(45);
                // Start timer only for SI/SN
                const pfx = row.transactionId.substring(0, 2);
                if (pfx === "SI" || pfx === "SN") {
                    setIsTimerActive(true);
                    startTimer();
                }
            })
            .catch((error) => {
                toast.error(error.message || "Failed to send OTP");
            });
    };

    // ---------- Timer Management ----------
    const startTimer = () => {
        if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
        setOtpTimer(45);
        timerIntervalRef.current = setInterval(() => {
            setOtpTimer(prev => {
                if (prev <= 1) {
                    clearInterval(timerIntervalRef.current);
                    timerIntervalRef.current = null;
                    setIsTimerActive(false);
                    if (isOtpModal) {
                        toast.error("OTP expired after 45 seconds. Please initiate refund again.");
                        handleHideModal();
                    }
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const stopTimer = () => {
        if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
            timerIntervalRef.current = null;
        }
        setIsTimerActive(false);
        setOtpTimer(45);
    };

    // ---------- Resend OTP ----------
    const handleResendOtp = () => {
        if (!refundData) return;
        sendOtpRequest(refundData.transactionId)
            .then(() => {
                toast.success("OTP resent successfully");
                const pfx = refundData.transactionId.substring(0, 2);
                if (pfx === "SI" || pfx === "SN") {
                    setIsTimerActive(true);
                    startTimer();
                }
            })
            .catch((error) => {
                toast.error(error.message || "Failed to resend OTP");
            });
    };

    // ---------- Modal Close ----------
    const handleHideModal = () => {
        setOtpModal(false);
        setOtp(null);
        setRefundOtpRef(null);
        setPrefix('');
        stopTimer();
    };

    // ---------- Page / Search Handlers ----------
    const handlePageChange = (page, size) => {
        setPage(page);
    };

    const onChangeStartDate = (date, dateString) => {
        setStartDate(date);
    };

    const onChangeEndDate = (date, dateString) => {
        setEndDate(date);
    };

    const handleSearch = () => {
        getDataReports();
    };

    const handleClear = () => {
        setStartDate('');
        setEndDate('');
        setSearchAccountNumber('');
        setSearchTransId('');
        setSearchCustomerId('');
        setPage(1);
        setTimeout(() => getDataReports(), 100);
    };

    // ---------- Effects ----------
    useEffect(() => {
        if (props.userId) {
            setUserId(props.userId);
        }
        getDataReports();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    useEffect(() => {
        return () => {
            if (timerIntervalRef.current) {
                clearInterval(timerIntervalRef.current);
                timerIntervalRef.current = null;
            }
        };
    }, []);

    // ---------- Render ----------
    if (isLoading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
        </div>;
    }

    return (
        <div className="">
            <div className="content p-0">
                <div className="container-fluid">
                    <div className='card'>
                        <div className='card-body'>
                            <div className="row">
                                <div className='col-md-12 date-search mb-0'>
                                    <div className='row'>
                                        <div className='col-md-4 col-lg-4 d-flex'>
                                            <div className="form-group mr-3">
                                                <label className='date-search-label mb-0 text-blue'>From</label>
                                                <DatePicker className="form-control form-control-border" value={startDate} format={dateFormat} onChange={onChangeStartDate} />
                                            </div>
                                            <div className="form-group">
                                                <label className='date-search-label mb-0 text-red'>To</label>
                                                <DatePicker className="form-control form-control-border" value={endDate} format={dateFormat} onChange={onChangeEndDate} />
                                            </div>
                                        </div>
                                        <div className='col-md-2 col-lg-2'>
                                            <div className="form-group">
                                                <label className='date-search-label mb-0 text-red'></label>
                                                <input type="text" className="form-control form-control-border" placeholder="Trans ID" onChange={(e) => setSearchTransId(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className='col-md-2 col-lg-2'>
                                            <div className="form-group">
                                                <label className='date-search-label mb-0 text-red'></label>
                                                <input type="text" className="form-control form-control-border" placeholder="A/C Number" onChange={(e) => setSearchAccountNumber(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className='col-md-2 col-lg-2'>
                                            <div className="form-group">
                                                <label className='date-search-label mb-0 text-red'></label>
                                                <input type="text" className="form-control form-control-border" placeholder="Customer ID" onChange={(e) => setSearchCustomerId(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className='col-md-1 col-lg-1'>
                                            <div><label className='date-search-label mb-0 text-red'>&nbsp;</label></div>
                                            <button type="submit" className="btn btn-primary rounded-pill px-3" onClick={handleSearch}>Search</button>
                                        </div>
                                        <div className='col-md-1 col-lg-1'>
                                            <div><label className='date-search-label mb-0 text-red'>&nbsp;</label></div>
                                            <button type="submit" className="btn btn-default rounded-pill px-4" onClick={handleClear}>Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid pt-2 pb-5">
                                <DataTable
                                    title={""}
                                    columns={columns}
                                    data={getData.docs}
                                    defaultSortFieldID={1}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={getTotalRecord}
                                    onChangeRowsPerPage={getDataReports}
                                    onChangePage={handlePageChange}
                                />
                            </div>
                        </div>
                    </div>

                    {/* OTP Modal */}
                    {isOtpModal && (
                        <Modal
                            title={"OTP Verification"}
                            width={600}
                            open={isOtpModal}
                            onCancel={handleHideModal}
                            footer={null}
                        >
                            <div className='row'>
                                {isTimerActive && (
                                    <div className='col-md-12 text-center mb-2'>
                                        <div style={{ color: "red", fontWeight: "600", fontSize: "14px" }}>
                                            ⏳ OTP expires in {otpTimer} seconds
                                        </div>
                                    </div>
                                )}
                                <div className='col-md-12 form-group'>
                                    <label>OTP Number: </label>
                                    <input
                                        type={'text'}
                                        className="form-group form-control"
                                        onChange={(e) => setOtp(e.target.value)}
                                        maxLength={10}
                                        value={isOtp}
                                        onKeyDown={isNumber}
                                    />
                                </div>
                                <div className='col-md-12 form-group text-right'>
                                    <button
                                        type='button'
                                        onClick={handleResendOtp}
                                        className='btn btn-sm btn-warning mr-2'
                                        disabled={otpSending || (isTimerActive && otpTimer === 0)}
                                    >
                                        {otpSending ? 'Sending...' : 'Resend OTP'}
                                    </button>
                                    <button
                                        type='button'
                                        onClick={handleHideModal}
                                        className='btn btn-sm btn-danger mr-2'
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type='button'
                                        onClick={handleRefundTransaction}
                                        className='btn btn-sm btn-primary'
                                        disabled={isTimerActive && otpTimer === 0}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </Modal>
                    )}
                </div>
            </div>
        </div>
    );
}

export default RefundHistory;